import { BotRequestParams, isSearchBotRequest, isSearchBotUserAgent } from './detector'

export const SEARCH_BOT_HEADER_NAME = 'x-bot-detected'

interface BotInfo {
	isDetected: boolean
}

export const botInfo = {
	isDetected: false
}

export const setBotInfo = (value: boolean) => {
	botInfo.isDetected = value
}

export const getBotInfo = (key: keyof BotInfo) => {
	return botInfo[key]
}

export { isSearchBotRequest, isSearchBotUserAgent, type BotRequestParams }
